import * as React from 'react'
import '../css/modal.css'

interface Data {
    title: string
    text: string
}

interface Props {
    data: Data
    show: boolean
    toggle: () => void
}

const StatusModal = (props: Props) => {

    const renderData = () => (
        <div className="modal-upper-block">
            <div className="modal-header">
                <div className="title-40">{props.data.title}</div>
                <div className="text-14">{props.data.text}</div>
            </div>
        </div>
    )

    return (
        <div className={'modal' + (props.show ? ' modal-show' : ' modal-hide')} >
            <div className="modal-card">
                <div className="close-modal-btn" onClick={props.toggle}/>
                {renderData()}
                <div className="modal-footer">
                    <button className="btn-modal-continue" onClick={props.toggle}>OK</button>
                </div>
            </div>
        </div>
    )
}

export default StatusModal


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/statusModal.tsx